import Stack from '@mui/material/Stack';
import '../App.css';
import GreyLightIcon from './GreyLightIcon';
import RedLightIcon from './RedLightIcon';
import { Styles } from '../Styles';

const RedGreyLightIcon = (props) => {
    const onOffBit = props.onOffBit;
    const onLabel = props.onLabel;
    const offLabel = props.offLabel;

    return (
        <>
            {onOffBit === '1' && (
                <Stack direction='row' sx={{ ...Styles.lightDisplay }}>
                    <RedLightIcon />
                    {onLabel}
                </Stack>
            )}
            {onOffBit === '0' && (
                <Stack direction='row' sx={{ ...Styles.lightDisplay }}>
                    <GreyLightIcon />
                    {offLabel}
                </Stack>
            )}
        </>
    );
};

export default RedGreyLightIcon;